import axiosInstance from './axiosInstance';

const tenantId = () => localStorage.getItem('epicxTenantId');

export const getChats = async () => {
  const epicxTenantId = tenantId();
  if (!epicxTenantId) {
    throw new Error('Tenant ID is missing');
  }
  const response = await axiosInstance.get(`/orders/api/chat/${epicxTenantId}`);
  return response.data.chats || [];
};

export const getChatMessages = async (userId) => {
  const epicxTenantId = tenantId();
  const response = await axiosInstance.get(
    `/orders/api/chat/${epicxTenantId}/${encodeURIComponent(userId)}`
  );
  return response.data;
};

export const replyToChat = async (userId, message) => {
  const epicxTenantId = tenantId();
  const response = await axiosInstance.post(
    `/orders/api/chat/${epicxTenantId}/${encodeURIComponent(userId)}/reply`,
    { message }
  );
  return response.data;
};
